import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

import { PAGE_SIZE_OPTIONS, STORE_INVOICE_LABELS } from "../types";

interface StoreInvoicePageSizeSelectProps {
  readonly value: number;
  readonly onChange: (value: number) => void;
}

export function StoreInvoicePageSizeSelect({
  value,
  onChange,
}: StoreInvoicePageSizeSelectProps) {
  return (
    <div className="flex items-center gap-2 text-xs text-slate-600">
      <span>{STORE_INVOICE_LABELS.pageSizeLabel}</span>
      <Select
        value={String(value)}
        onValueChange={next => onChange(Number(next))}
      >
        <SelectTrigger className="h-8 w-[72px] bg-white text-xs">
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          {PAGE_SIZE_OPTIONS.map((option: number) => (
            <SelectItem key={option} value={String(option)} className="text-xs">
              {option}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}
